import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jsm_va_enable_ai_answers_page');
	},
};
